<ph-dialog [open]="open" size="md" [heading]="copy.title" (ph-close)="closed.emit(null)">
    <ph-stack>
        <div>{{ copy.intro }}</div>
        <div class="list-styled">
            <ul>
                <li *ngFor="let label of labels; trackBy: trackByLabel">{{ label }}</li>
            </ul>
        </div>
        <div>{{ copy.outro }}</div>
    </ph-stack>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="closed.emit(null)">Cancel</ph-button>
        <ph-toolbar>
            <ph-button variant="secondary" mode="filled" (click)="closed.emit('review-settings')">{{ copy.secondaryButton }}</ph-button>
            <ph-button (click)="closed.emit('continue')">{{ copy.confirmButton }}</ph-button>
        </ph-toolbar>
    </ph-actions>
</ph-dialog>
